export default "__VITE_ASSET__d940a197__"